import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Handle chunk loading errors by reloading the page
window.addEventListener('error', (event) => {
  if (event.message?.includes('Loading chunk') || 
      event.message?.includes('Failed to fetch dynamically imported module')) {
    console.warn('Chunk loading failed, reloading page...');
    window.location.reload();
  }
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));